<template>
  <v-flex xs12 md5 offset-md2>
    <h1 class="text-xs-center">This is an about page</h1>
  </v-flex>
</template>

<script>
export default {};
</script>
